import * as _ from "lodash"


export interface IHasIncluded {
    getIncluded(): boolean | undefined
    setIncluded(included: boolean): void
}

function hasIncluded<TBase extends Constructor>(Base: TBase) {
    return class extends Base implements IHasIncluded {
        private included: boolean | undefined

        constructor(...args: any[]) {
            super(...args);
        }

        public getIncluded(): boolean | undefined {
            return this.included
        }
        public setIncluded(included: boolean): void {
            this.included = included
        }
    };
}

export default hasIncluded